import { signupFields } from "../constants/formFields";

const fieldLabels = signupFields.reduce((labels, field) => {
  labels[field.name] = field.labelText;
  return labels;
}, {});

const formatValidationMessage = (error) => {
  const label = fieldLabels[error.loc?.[error.loc.length - 1]] || "This field";
  if (error.type === "string_too_short") {
    return error.ctx?.min_length > 1
      ? `${label} must contain at least ${error.ctx.min_length} characters.`
      : `${label} cannot be blank.`;
  }
  if (error.type === "string_too_long") return `${label} is too long.`;
  return (error.msg || "Invalid value.").replace(/^Value error,\s*/i, "");
};

export const getSignupValidationErrors = (error) => {
  const details = error.response?.status === 422 && error.response?.data?.detail;
  if (!Array.isArray(details)) return null;

  return details.reduce((errors, detail) => {
    const fieldName = detail.loc?.[detail.loc.length - 1];
    if (fieldLabels[fieldName] && !errors[fieldName]) {
      errors[fieldName] = formatValidationMessage(detail);
    }
    return errors;
  }, {});
};

export const getSignupErrorMessage = (error) => {
  const { status, data } = error.response || {};
  return status === 409 && typeof data?.detail === "string" ? data.detail : null;
};
